// @ts-nocheck
import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { defPath, fetchPath } from '../../config/defPath';
import { useCamerino, useSession } from '../../hooks/useState';
import { SignatureTextures } from '../../config/types';
import { customDataset } from '../../config/customDataset';
import texJson from '../../config/textures.json'
import gsap from 'gsap';

import { PopsController } from '../../classes/popsController'
import { triggerCustomEvent } from '../../classes/eventController';

import "@melloware/coloris/dist/coloris.css";
import Coloris from "@melloware/coloris";
import Alert from './Alert';

const textures: SignatureTextures = texJson

const categoryList: { [category: string]: any } = {
  estilos: {
    id: 'Est',
    image: '/assets/images/customizePlayer/man.png',
    name: 'estilo',
    side: 'right'
  },
  up: {
    id: 'Sup',
    image: '/assets/images/customizePlayer/camisa.png',
    subname: 'parte',
    name: 'superior',
    side: 'right'
  },
  down: {
    id: 'Inf',
    image: '/assets/images/customizePlayer/pants.png',
    subname: 'parte',
    name: ' inferior',
    side: 'right'
  },
  accesorios: {
    id: 'Acc',
    image: '/assets/images/customizePlayer/glasses.png',
    name: 'accesorios',
    side: 'left'
  },
  calzado: {
    id: 'Cal',
    image: '/assets/images/customizePlayer/shoe.png',
    name: 'calzados',
    side: 'left'
  },
  canjeables: {
    image: '/assets/images/customizePlayer/money.png',
    name: 'canjear',
    side: 'left'
  },
}

const dictionarySubCategory: { [sub: string]: string } = {
  genero: 'genero',
  piel: 'piel',
  cabello: 'cabellos',
  barba: 'barbas',
  camiseta: 'camisetas',
  chaqueta: 'chaquetas',
  hoodie: 'hoodies',
  'pant-corta': 'pantalonetas',
  'pant-larga': 'pantalonetas',
  jean: 'jean',
  jeanOro: 'jean',
  pesquero: 'pesquero',
  hopper: 'hopper',
  sombrero: 'sombreros',
  gafa: 'gafas',
  guante: 'guantes',
  guayo: 'guayos',
  guayos: 'guayos',
  guayosOro: 'guayos',
  tenis: 'tenis',
  botin: 'botines',
  botines: 'botines',
  medias: 'medias',
}

const regex: { [type: string]: (gender: string) => RegExp } = {
  piel: (gender) => new RegExp(`[a-zA-Z]+-${gender.charAt(0).toUpperCase()}_`),
  cabellos: (gender) => new RegExp(`[a-zA-Z]+-${gender.charAt(0).toUpperCase()}-`)
}

declare global {
  interface Window {
    json_avatar: string
  }
}
// window.avatar.jsonTemp = `{ "gender": "hombre", "skin": "C", "hair": {"type": "01", "color": "01" }, "beard": {"type": "00", "color": "01" }, "up": {"type": "camiseta", "code": "01"}, "down": {"type": "pant-corta", "code": "01"}, "socks": {"type": null, "code": "01"}, "shoes": {"type": "guayos", "code": "01"}, "accesories": [ {"type": "guante", "code": "01"}, ] }`

interface PropsDressingRoom {
  closeMenu: () => void,
  updatePant: (isPant: boolean) => void;
  animateToggle: boolean
  setAnimateToggle: Dispatch<SetStateAction<boolean>>,
}

export default function DressingRoom({ closeMenu, updatePant, animateToggle, setAnimateToggle }: PropsDressingRoom) {
  const containerAnimate = useRef<HTMLDivElement>(null);
  const [productActive, setProductActive] = useState('')
  const [subCategoryActive, setSubCategoryActive] = useState('')
  const [categoryActive, setCategoryActive] = useState('')
  const { category } = useCamerino(state => state) // up - down ...
  const [showColorPick, setShowColorPick] = useState(true);
  const { user } = useSession(state => state)
  const [showLoQuiero, setShowLoQuiero] = useState(false)

  function showBarba(show: boolean) {
    const listCat = document.querySelector('.dressing_room__items--category .cat-barbas') as HTMLElement
    if (!listCat) return
    show ? listCat.classList.remove('disabled') : listCat.classList.add('disabled')

  }

  useEffect(() => {
    if (category) setSubCategoryActive(Object.keys(textures[category])[0])
    user.json_avatar.genero.includes('Hombre') ? showBarba(true) : showBarba(false)
  }, [])

  useEffect(() => {
    window.avatar.initEditor()
    setCategoryActive(subCategoryActive)
  }, [subCategoryActive])

  useEffect(() => {
    window.avatar.initEditor()
  }, [user])

  useEffect(() => {
    // mostrar u ocultar barba
    category.includes('estilos') && productActive.length && productActive.includes('hombre') && showBarba(true)
    category.includes('estilos') && productActive.length && productActive.includes('mujer') && showBarba(false)

    window.avatar.initEditor()
  }, [productActive])

  useEffect(() => {
    category.includes('estilos') && showBarba(window.avatar.jsonTemp.genero.includes('Hombre'))
  }, [category])

  const handleProductActive = async (name: string, event?: any) => {
    window.soundController && window.soundController.play('clic', false, 1)
    if (category === 'canjeables') {
      window.avatar.resetAvatarStyle()

      let canjeableSelected = /\w+_p-(?<price>[0-9]+)/.exec(name)
      if (canjeableSelected) {
        if (Number(canjeableSelected.groups?.price) < Number(user.coins)) {
          setShowLoQuiero(true)
        } else {
          setShowLoQuiero(false)
        }

      }
    }

    setProductActive(name)
  }

  const handleCloseMenu = () => {
    window.soundController && window.soundController.play('cerrar', false, 1)
    window.avatar.resetAvatarStyle && window.avatar.resetAvatarStyle()
    setAnimateToggle(false)
    setTimeout(() => {
      closeMenu()
    }, 350)
  }

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      const widthSize = window.innerWidth;
      const timeline = gsap.timeline({
        defaults: {
          ease: 'power1.out',
          duration: .3,
        }
      })

      if (animateToggle) {
        timeline.from('.dressing_room__categories', { opacity: 0, yPercent: 100, xPercent: 50 })
        timeline.from('.dressing_room__items', { opacity: 0, yPercent: 100, duration: .5 }, .2)
        timeline.from('.btnTypeCustomize', { opacity: 0, xPercent: widthSize <= 1119 ? 100 : -100 }, .9)

      } else {
        timeline.to('.btnTypeCustomize', { opacity: 0, xPercent: widthSize <= 1119 ? 100 : -100, duration: .8 })
        timeline.to('.dressing_room__categories', { opacity: 0, yPercent: 100, xPercent: 50 })
        timeline.to('.dressing_room__items', { opacity: 0, yPercent: 100, duration: .5 }, .2)
      }


    }, containerAnimate);

    setTimeout(() => {
      let ctx = gsap.context(() => {
        const timeline = gsap.timeline({
          defaults: {
            ease: 'power1.out',
            duration: 1,
            stagger: .2,
          }
        })

        if (animateToggle) {
          timeline.from('.bodySlider .dressing_room__card', { opacity: 0, yPercent: 100 })

        } else {
          timeline.to('.bodySlider .dressing_room__card', { opacity: 0, yPercent: 100 })
        }
      }, containerAnimate);

      return () => ctx.revert();
    }, 300);

    return () => ctx.revert();
  }, [animateToggle]);

  return (
    <div className='dressing_room' ref={containerAnimate}>

      <div className="dressing_room__controls">

        <div className="btnTypeCustomize">
          {
            category && (
              <div className="btnTypeCustomize__body">
                <p className="content whiteShadow black_30">
                  <span className='small'>{categoryList[category].subname}</span>
                  {categoryList[category].name}
                </p>
                {
                  categoryList[category].name === 'canjear' &&
                  <div className="coinBox">
                    <p className="content whiteShadow black_30 opacity textCoins">
                      Monedas
                    </p>
                    <img src={`${defPath}/assets/images/camerino/coin.svg`} alt="" />
                  </div>
                }
                <div onClick={handleCloseMenu} className="btnClose">
                  <a className="close__modal close"></a>
                </div>
              </div>
            )
          }
        </div>
      </div>

      <div className="dressing_room__wrapper">

        <MenuSubCategories category={category} changeSubategory={setSubCategoryActive} />

        <div className="dressing_room__items">

          {category !== "canjeables" && (
            <div className='dressing_room__items--category'>
              <CategoriesBox category={category} changeSubategory={setSubCategoryActive} />
            </div>
          )}

          {/* Seccion de las tarjetas de los productos */}
          <div className="dressing_room__slider">
            { categoryActive !== "0" && <p className='dressing_room__slider--category title_2 yellowShadow'>{categoryActive === 'genero' ? 'Género' : categoryActive}</p> }

            {/* Seccion de Colores (Cabello, Barba) */}
            {showColorPick && ['cabellos'].includes(subCategoryActive) &&
                <ColorPicker
                  category={'cabello'}
                  defaultColor={`#${window.avatar.jsonTemp.cabello.color}`}
                  />
                }
            {showColorPick && ['barbas'].includes(subCategoryActive) &&
                <ColorPicker
                category={'barba'}
                  defaultColor={`#${window.avatar.jsonTemp.barba.color}`}
                />
            }
            
            <div className="bodySlider">
              {
                category === "canjeables" ?
                  subCategoryActive && textures[category].map((name: string) => {
                    const {dataA, ...config} = customDataset(name)

                    return (
                      <div 
                        key={name} 
                        className={`dressing_room__card canjeable_ ${productActive === name ? ' active' : ''}${user?.list_articles?.includes(name.replace('.png', '')) ? ' ar__disabled' : ''}`}
                        onClick={(event) => handleProductActive(name, event)} 
                        {...config} 
                        >
                        <div className="price">
                          <div className="price__body">
                            <div className="img">
                              <img src={`${defPath}/assets/images/icons/coins.png`} alt="item" />
                            </div>
                            <div className="priceValue">
                              <p className='black_24'>{name.split('_p-')[1].replace('.png', '')}</p>
                            </div>
                          </div>
                        </div>
                        <img src={`${defPath}/assets/images/thumbnail/${name}`} alt="item" />
                      </div>
                    )
                  }) : (
                    <>
                      {/* Se mapean los productos canjeados en su respectiva categoria */}
                      {
                        subCategoryActive && user?.list_articles && user.list_articles.map((name: string) => {
                          let [fileCategory, fileSubcategory] = name.split('_');
                          let categoryIndex = Object.values(categoryList).findIndex(item => item.id == fileCategory)
                          const {dataA, ...config} = customDataset(name)

                          if (Object.keys(categoryList)[categoryIndex] === category &&
                            dictionarySubCategory[fileSubcategory] === subCategoryActive) {
                            return (
                              <div 
                                key={name}
                                className={`dressing_room__card top${productActive === name ? ' active' : ''}`}
                                onClick={() => handleProductActive(name)}
                                data-a={productActive ? "false" : dataA}
                                {...config}
                              >
                                <img src={`${defPath}/assets/images/thumbnail/${name}.png`} alt="item" />
                              </div>
                            )
                          }
                        })
                      }
                      {/* Se mapean los productos en cada categoria */}
                      {
                        subCategoryActive && textures[category][subCategoryActive].map((name: string) => {
                          const {dataA, ...config} = customDataset(name)
                          
                          if (['piel', 'cabellos'].includes(subCategoryActive)) {
                            return name.match(regex[subCategoryActive]?.(window.avatar.jsonTemp.genero)) &&
                              <div 
                                key={name} 
                                className={`dressing_room__card${productActive === name ? ' active' : ''}`}
                                onClick={() => handleProductActive(name)} 
                                data-a={productActive ? "false" : dataA}
                                {...config}
                              >
                                <img src={`${defPath}/assets/images/thumbnail/${name}`} alt="item" />
                              </div>
                          }
                          else {
                            return (
                            <div 
                              key={name} 
                              className={`dressing_room__card${productActive === name ? ' active' : ''}`}
                              onClick={() => handleProductActive(name)} 
                              data-a={productActive ? "false" : dataA}
                              {...config}
                            >
                                <img src={`${defPath}/assets/images/thumbnail/${name}`} alt="item" />
                            </div>)
                          }
                        })
                      }
                    </>
                  )}
            </div>
          </div>
        </div>

        <SubCategories category={category} user={user} changeSubategory={setSubCategoryActive}  showLoQuiero={showLoQuiero} productActive={productActive} setAnimateToggle={setAnimateToggle} closeMenu={ closeMenu } />
      </div>
    </div>
  )
}

const MenuSubCategories = ({ category, changeSubategory }) => {
  return (
    <div className={`dressing_room__card--wrapper ${category == "canjeables" ? 'onlyText' : ''}`}>
      {
        category && (
          <p className="categoryText whiteShadow black_45">
            <span className='small'>{categoryList[category].subname}</span>
            {categoryList[category].name}
          </p>
        )
      }
      {category !== "canjeables" && 
        <CategoriesBox category={category} changeSubategory={changeSubategory} />
      }
    </div>
  )
}

const CategoriesBox = ({ category, changeSubategory }) => {
  const [itemActive, setItemActive] = useState(0)

  const handleSubCategoryActive = (name: string) => {
    setItemActive(name)
    changeSubategory(name)
  }

  const scrollTop = () => {
    window.soundController.play('camerino_second', false, 1)
    const boxItem = document.querySelector('.bodySlider') as HTMLElement
    if (boxItem) {
      boxItem.scrollTop = 0
    }
  }

  return (
    <div>
      {
        category !== "canjeables" && textures[category] && Object.keys(textures[category]).map((item, index) => {
        const estilos = ["barbas", "cabellos", "piel", "genero"]
          return (
            <div key={index}
              onClick={() => handleSubCategoryActive(item)}
              className={`dressing_room__card  cat-${item} ${itemActive === item || itemActive === index ? ' active' : ''}`}
            >
              <div className="dressing_room__card--box" onClick={scrollTop}>
                {
                  item 
                    ? <img src={`${defPath}/assets/images/thumbCategories/${item}.png`} alt="item" />
                    : "" 
                }
              </div>
              <div className="dressing_room__card--name">{item === 'genero' ? 'género' : item}</div>
            </div>
          )
        })
      }
    </div>
  )
}

const SubCategories = ({ category, changeSubategory, productActive, setAnimateToggle, closeMenu, showLoQuiero }) => {
  const user = useSession(state => state.user)

  const handleDesplegable = (e: any) => {
    e.preventDefault()
    e.target.parentElement.classList.toggle('reverse')
    // e.target.parentElement.style.pointerEvents = "none"
    document.querySelector('.dressing_room__slider')?.classList.toggle('dobleLine')
    // setTimeout(() => e.target.parentElement.style.pointerEvents = "auto", 1000)
  }

  const showRedeemPopup = async () => {
    if (productActive) {
      
      // DATALAYER
      let articleName = document.querySelector(".dressing_room__slider .dressing_room__card.active")?.getAttribute("data-v")
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': `${articleName} - Redeem Coins`,
        'interaction':'true',
        'component_name': 'Modo_Carrera_CoinRedemption',
        'element_text': 'Lo quiero',
      });

      let response = /\w+_p-(?<price>[0-9]+)/.exec(productActive)
      if (response) {
      
        if (Number(response.groups?.price) < Number(user.coins)) {
          new PopsController().open('redeem', {
            points: response.groups?.price,
            article: productActive
          })
        } else {
          window.openAlert({
            title: `Algo ha salido mal...`,
            desc: `No tienes monedas suficientes para redimir.`,
            type: `error`,
            time: 5000
          })
        }

      }
    }
  }

  async function sendAvatar() {
    let url = `${fetchPath}/aguila/loyalty/save/avatar`

    try {
      let info = { json: window.avatar.jsonTemp }

      let res: any = await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(info)
      })

      let data = await res.json()

      if (res.ok) {
        window.avatar.purchasedItem()

        let userData = JSON.parse(sessionStorage.getItem("user-estadio"))
        userData.state.user.json_avatar = info.json
        sessionStorage.setItem('user-estadio',  JSON.stringify(userData))

        //DATALAYER
        let sectionName = document.querySelector(".categoryText")?.textContent
        let articleName = document.querySelector(".dressing_room__slider .dressing_room__card.active")?.getAttribute("data-v")
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Button',
          'event_label': articleName,
          'interaction':'true',
          'component_name': 'Modo_Carrera_AvatarMenu',
          'element_text': sectionName,
        });

        setAnimateToggle(false)
        setTimeout(() => {
          closeMenu()
        }, 350)
        triggerCustomEvent('renderAlert', {
          title: '¡Que estilo!',
          desc: `${data.message}`,
          type: 'great',
          time: 3000
        })
      }
    }

    catch (error) {
      console.warn("error", error)
    }
  }

  return (
    <div className="dressing_room__categories">

      <button onClick={handleDesplegable} className='dressing_room--btnMore'>
        <img src={`${defPath}/assets/images/icons/more.svg`} alt="icono select" />
      </button>

      {
        category === 'canjeables'
          ? <button 
            onClick={showRedeemPopup} 
            className={`ar__btn-primary ${showLoQuiero ? "" : "ar__hide"}`}>lo quiero</button>
          : <button onClick={sendAvatar} className={`ar__btn-primary ${productActive === '' ? "ar__hide" : ""}`}>Guardar</button>
      }
    </div>
  )
}

const ColorPicker = ({ defaultColor, category }) => {
  // const colorHex = category === 'barbas' ? `#${window.avatar.jsonTemp.barba.color}` : `#${window.avatar.jsonTemp.cabello.color}`
  // document.documentElement.style.setProperty('--colorisDefault', colorHex);

  let itemActive = ''

  const config = {
    el: "#coloris",
    parent: '.dressing_room',
    alpha: false,
    defaultColor: defaultColor,
    themeMode: 'dark',
    theme: 'polaroid', // -> default, large, polaroid, pill
    swatches: [
      '#FFE100',
      '#002D6E',
      '#ff0000',
      '#00ff00',
      '#0000ff',
      '#ffff00',
      '#ff00ff',
      '#00ffff',
      '#d4d4d4',
      '#ffffff',
      '#000000',
      '#cccccc'
    ],
    onChange: (color: string) => {
      
      window.avatar.changeColor(`${category}_${color.replace('#', '')}`)

      if(itemActive !== category) {
        const itemBtn = document.querySelector(`[data-v='${avatar.jsonTemp[category].type}']`)
        itemBtn && itemBtn.click()
        itemActive = category
      }

    }
  }

  useEffect(() => {
    Coloris.init()
    Coloris(config);
  }, []);

  useEffect(() => {
    Coloris(config);
  }, [category]);

  return (
    <div className="dressing_room__colors">
      <div className='coloris-container'>
        <input type="text"  data-coloris id='coloris' readOnly={true}/>
        <label htmlFor="coloris"></label>
      </div>
    </div>
  )
}